import { GlobeHemisphereWest } from '@phosphor-icons/react';
import { useNavigate } from 'react-router-dom';
import { users as usersApi } from '../../api/endpoints';
import { ScreenError, ScreenLoader, SubScreen } from '../../components/layout/Screens';
import { Button } from '../../components/ui/Button';
import { useAsync } from '../../hooks/useAsync';
import { useSession } from '../../store/SessionContext';
import { number } from '../../utils/format';
import { t } from '../../i18n';

/**
 * Toutes les destinations d'un membre.
 *
 * Rien n'est encarte. Le chiffre du haut pose sur le fond, et chaque
 * destination est une ligne — pas une carte. Trois cartes dans une carte ne
 * hierarchisaient rien : elles ajoutaient juste six bordures a lire.
 */
export function DestinationsScreen() {
  const { user } = useSession();
  const navigate = useNavigate();
  const { data, loading, error, reload } = useAsync(() => usersApi.myProfile(), [], 'profile');

  return (
    <SubScreen title={t.profil.commun.mesDestinations}>
      {loading && <ScreenLoader />}
      {error && <ScreenError message={error} onRetry={reload} />}

      {data && (
        <>
          <div className="pr-stats">
            <div className="pr-stat">
              <p className="pr-stat__label">{t.profil.destinations.villes}</p>
              <p className="pr-stat__value">{number(data.stats.cities)}</p>
            </div>
          </div>

          {data.destinations.map((destination) => (
            <section key={destination.serverId} className="pr-dest">
              <div className="pr-dest__head">
                <span className="pr-dest__name">{destination.serverName}</span>
                {destination.serverId === user?.currentServerId && (
                  <span className="pr-dest__current">{t.profil.destinations.actuel}</span>
                )}
              </div>
            </section>
          ))}

          <div className="pr-switch">
            <Button
              variant="soft"
              icon={<GlobeHemisphereWest size={20} />}
              onClick={() => navigate('/choose-spot')}
            >
              {t.profil.destinations.changer}
            </Button>
          </div>
        </>
      )}
    </SubScreen>
  );
}
